import { Link } from "react-router-dom";

export default function AppDisclaimer() {
  return (
    <footer className="py-6 text-center text-xs text-white/30">
      <p>SEND IT is unofficial and not associated with Formula 1 or FIA.</p>
      <div className="mt-1 flex justify-center gap-2">
        <Link to="/terms" className="text-white/40 transition-colors hover:text-white/60">Terms</Link>
        <span>·</span>
        <Link to="/privacy" className="text-white/40 transition-colors hover:text-white/60">Privacy</Link>
        <span>·</span>
        <Link to="/disclaimer" className="text-white/40 transition-colors hover:text-white/60">Disclaimer</Link>
      </div>
    </footer>
  );
}
